import PullRequestCtrl from '../../components/pull-request/pull-request/PullRequest.data';

export default function RepoPullRequest() {
	return <PullRequestCtrl />;
}
